import Vue from 'vue';

function loadingLayout() {
    return{
        showLoading: false
    }
}

function defaultConfig() {
    return{
        name: null,
        description: null,
    }
}

function requestForm() {
    return {
        hash_id: null,
        cat_status_id: null,
        form: null,
        paymentIsValid: false,
        payment: paymentForm()
    }
}

function userRequest(){
    return{
        id: null,
        documents: [],
        isPreregister: null,
        requirements: [],
        showModal: false,
        try: 0,
        modal: false

    }
}

function makeProcedure() {
    return{
        category: null,
        procedure: null,
        name: null,
        description: null,
        showInfoMessage: null,
        messages: [],
        nameProcedure: null,
        isSigned: false,
        isHelp: false,
        aliasProcedure: null
    }
}
function paymentForm() {
    return{
        chainDependence: null,
        firstName: null,
        secondName: null,
        name: null,
        denomination: null,
        date: null,
        total: null,
        operationNumber: null,
        paymentKey: null,
    }
}


const state = {
    userRequest: userRequest(),
    loadingLayout: loadingLayout(),
    makeProcedure: makeProcedure(),
    defaultConfig: defaultConfig(),
    requestForm: requestForm()
};

const mutations = {

    addUserDoc(state, payload) {
        state.userRequest.documents.push(
            {
                "id": null,
                "file_id": payload.file_id,
                "fileNameHash": payload.fileNameHash,
                "document_type_id": null,
                "section_id" : payload.section_id,
                "isActive": true,
                "fileName": payload.fileName,
                "description" : null
            }
        );
    },

	addDoc(state, payload) {
		state.model.documents.push(
			{
				"id": null,
				"file_id": payload.file_id,
				"document_type_id": null,
				"fileNameHash": payload.fileNameHash,
				"section_id" : payload.section_id,
				"isActive": true,
				"fileName": payload.fileName,
				"description" : null
			}
		);
	},

	removePublicDocument(state, payload) {
		let index = state.userRequest.documents.indexOf(payload);
		state.userRequest.documents.splice(index, 1);
	},

    removeDocument(state, payload) {
		let index = state.model.documents.indexOf(payload);
		state.model.documents.splice(index, 1);
	},

    addProcedureData(state,data){
        state.makeProcedure = data;
    },

    modifyRequest(state, data){
        state.userRequest = data
    }

};

const actions = {

    fetchSigle({state, commit, dispatch}, {crypt_id} = {}) {

        dispatch('loading/spinner', {msg: 'Cargando Información...', status: true}, {root: true});

        return axios.get(`/api/get-documents/${crypt_id}`)
            .then((res) => {
                dispatch('loading/spinner', {}, {root: true});

                const parsedResponse = res.data;
                if (parsedResponse) {

                    return parsedResponse;
                } else {
                    return Promise.reject(parsedResponse);
                }

            })
            .catch((err) => {
                console.log(err);
                dispatch('loading/spinner', {}, {root: true});
                let msg = 'No se pudo completar la acción';
                if (err.response &&
                    err.response.data &&
                    err.response.data.message
                    && err.response.status == 400) {
                    msg = err.response.data.message;
                }
                dispatch('notifications/error', {msg: msg}, {root: true});
                return Promise.reject(err);

            });
    },

    addProcedureData({commit},data){
        commit('addProcedureData',data);
    },

    modifyRequest({commit},data){
        commit('modifyRequest',data)
    }

};

const getters = {
    requestForm: state => state.requestForm,
    loadingLayout: state => state.loadingLayout,
    makeProcedure: state => state.makeProcedure,
    defaultConfig: state => state.defaultConfig,
    userRequest: state => state.userRequest,

};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};

